import React from "react";
import "../assets/styles/RouteLoading.scss";

// Suspense fallback shown only during client-side route transitions to a
// lazy-loaded page chunk. Prerendered pages hydrate from existing markup
// and never show this — it's purely for in-app navigation.
const RouteLoading: React.FC = () => (
  <div className="route-loading" role="status" aria-label="Loading page">
    <span className="route-loading-dot" />
    <span className="route-loading-dot" />
    <span className="route-loading-dot" />
  </div>
);

export default RouteLoading;
